import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Adds the browser's detected IANA timezone (e.g. America/New_York)
 * to every outbound request as `X-Browser-Timezone`. Backend reads it
 * on protected requests and keeps `users.timezone` in sync with it
 * (unless the user pinned a manual choice).
 *
 * Lighter-touch than the per-session detection effect: header lands on
 * every API call, so the first request after deploy / first request on
 * a new device backfills automatically without depending on auth-state
 * timing or fresh logins.
 */
function detect(): string | null {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
    } catch {
        return null;
    }
}

const TZ = detect();

export const timezoneInterceptor: HttpInterceptorFn = (req, next) => {
    if (!TZ) {
        return next(req);
    }
    return next(req.clone({ setHeaders: { 'X-Browser-Timezone': TZ } }));
};
